module.exports = __webpack_public_path__ + "media/packs/images/markers/sailing-location-badedba74c587dd4f4e2ca0e0dde913e.svg";